import React from 'react';
import { CheckIcon } from 'lucide-react';
import { transformSection } from '../data/copy';
import { OFFER_ANCHOR } from './constants';
export function TransformSection() {
  return <section className="bg-white px-3 py-3 sm:px-4 sm:py-4" data-id="element-233" data-mp="2legzv97qjfhq">
      <div className="mx-auto max-w-4xl text-center" data-id="element-234" data-mp="2lg1tmwm86uej">
        <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight tracking-tight sm:text-4xl" data-id="element-235" data-mp="2qciijt191cso">
          {transformSection.title}
        </h2>
        <p className="mb-1.5 text-[12.5px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-236" data-mp="3e11t6f7ru1nx">
          {transformSection.intro}
        </p>

        <ul className="mx-auto mb-1.5 grid max-w-3xl grid-cols-2 gap-1 sm:grid-cols-4" data-id="element-237" data-mp="343nae8ydl0sg">
          {transformSection.items.map(item => <li key={item} data-id="element-238" data-mp="395w7nhia6p0d">
              <a href={OFFER_ANCHOR} className="flex h-full items-center gap-1 rounded-md border border-pf-creamDark bg-pf-cream px-2 py-1.5 text-left text-[11.5px] font-bold leading-tight text-pf-navy transition-colors duration-150 ease-out hover:border-pf-coral sm:text-[13px]" data-id="element-239" data-mp="1sptab1fye3yd">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-pf-sage" aria-hidden="true" data-id="element-240" data-mp="19nnvjhlah2lm" />
                {item}
              </a>
            </li>)}
        </ul>

        <div className="mx-auto max-w-3xl space-y-0.5 text-[12.5px] font-medium leading-snug text-pf-ink sm:text-base" data-id="element-241" data-mp="1inkfx70nbfav">
          <p data-id="element-242" data-mp="1wm0iclrh6jn7">{transformSection.close[0]}</p>
          <p className="font-bold text-pf-navy" data-id="element-243" data-mp="1wkz4k9j2rj1s">{transformSection.close[1]}</p>
          <p className="font-display text-[13px] font-extrabold uppercase text-pf-coral sm:text-lg" data-id="element-244" data-mp="1skys2ufjdhxd">
            {transformSection.close[2]}
          </p>
        </div>
      </div>
    </section>;
}